// 所有插件
import Vue from 'vue'
import Cookie from 'js-cookie'
// echarts图表插件
// import * as echarts from 'echarts'
import { Toast, Dialog } from 'vant'

// lodash插件
import findKey from 'lodash/findKey.js'
// 多语言
import VueI18n from 'vue-i18n'

// Vue.prototype.$echarts = echarts
Vue.prototype.$Cookie = Cookie
Vue.prototype.$Toast = Toast
Vue.prototype.$Dialog = Dialog

// Vue.use(ElementUI, { locale })
Vue.use(VueI18n)
// let i = 0
VueI18n.prototype.translation = function (value) {
  const zh = require('~/static/languages/TXT_zh-CN.json')
  const val = findKey(zh, function (o) {
    // console.log(i++, 123, value, 345, o)
    return o == value
  })
  if (!val) {
    return value + '(前端未翻译)'
  }
  return this.$t(val)
}

export default async ({ app, store, params }) => {
  const isExist = store.state.langList.includes(params?.lang?.toLowerCase()) ? params.lang.toLowerCase() : 'en'
  let langObj = {}
  if (isExist != 'en') {
    const langPack = await import(/* webpackChunkName: "lang-[request]" */ `~/static/languages/TXT_${handleCn(isExist)}.json`).catch(() => {})
    langObj = { [isExist]: langPack }
  }
  // console.log(handleCn(isExist), 222, params)
  app.i18n = new VueI18n({
    silentTranslationWarn: true,
    locale: isExist,
    fallbackLocale: 'zh-cn',
    messages: {
      // 'zh-cn': require('~/static/languages/TXT_zh-CN.json'),
      // ar: require('~/static/languages/TXT_ar.json'),
      en: require('~/static/languages/TXT_en.json'),
      ...langObj
      // de: require('~/static/languages/TXT_de.json'),
      // es: require('~/static/languages/TXT_es.json'),
      // fil: require('~/static/languages/TXT_fil.json'),
      // fr: require('~/static/languages/TXT_fr.json'),
      // hi: require('~/static/languages/TXT_hi.json'),
      // id: require('~/static/languages/TXT_id.json'),
      // it: require('~/static/languages/TXT_it.json'),
      // ja: require('~/static/languages/TXT_ja.json'),
      // ko: require('~/static/languages/TXT_ko.json'),
      // ms: require('~/static/languages/TXT_ms.json'),
      // pt: require('~/static/languages/TXT_pt.json'),
      // ru: require('~/static/languages/TXT_ru.json'),
      // th: require('~/static/languages/TXT_th.json'),
      // vi: require('~/static/languages/TXT_vi.json'),
      // tr: require('~/static/languages/TXT_tr.json'),
      // zh: require('~/static/languages/TXT_zh.json'),
      // 'zh-hk': require('~/static/languages/TXT_zh-HK.json'),
      // 'zh-tw': require('~/static/languages/TXT_zh-TW.json')
    }
  })

  Vue.prototype.$v = app.i18n.translation
}

// 处理中文语言字符
function handleCn(str = 'en') {
  if (str?.includes('-')) {
    const cutArr = str?.split('-')
    return [cutArr[0], cutArr[1]?.toUpperCase()].join('-')
  } else return str
}
